/**
 * Number formatting for the result screen, in Danish conventions.
 *
 * Every formatter renders `null` as "ikke målt" rather than as a zero. That is the whole point of
 * this module: a missing counter and a counter that read zero mean opposite things, and showing
 * the first as "0" would turn "we could not measure this" into "this was perfect".
 */

import * as da from '@/strings/da'

const LOCALE = 'da-DK'

export function formatPercent(value: number | null): string {
	if (value === null) return da.call.notMeasured
	return `${value.toLocaleString(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %`
}

export function formatMs(value: number | null): string {
	if (value === null) return da.call.notMeasured
	return `${Math.round(value).toLocaleString(LOCALE)} ms`
}

export function formatCount(value: number | null): string {
	if (value === null) return da.call.notMeasured
	return value.toLocaleString(LOCALE)
}

export function formatScore(value: number | null): string {
	if (value === null) return da.call.notMeasured
	return `${Math.round(value)} / 100`
}

/** Packets per second. One decimal, so a real difference between the two columns is visible. */
export function formatRate(value: number | null): string {
	if (value === null) return da.call.notMeasured
	return `${value.toLocaleString(LOCALE, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}/s`
}

/** A measurement window, in seconds. */
export function formatDuration(ms: number | null): string {
	if (ms === null) return da.call.notMeasured
	return `${(ms / 1000).toLocaleString(LOCALE, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} s`
}

export function formatSeconds(ms: number): number {
	return Math.round(ms / 1000)
}
